import React from 'react';
import PropTypes from 'prop-types';
import { ToggleWrapper, StyledBG, StyledLeft, StyledRight, StyledHandle } from './styled';

var OnOffToggle = function OnOffToggle(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === undefined ? false : _ref$checked,
      onToggle = _ref.onToggle,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 64 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 28 : _ref$height,
      _ref$activeText = _ref.activeText,
      activeText = _ref$activeText === undefined ? 'ON' : _ref$activeText,
      _ref$inactiveText = _ref.inactiveText,
      inactiveText = _ref$inactiveText === undefined ? 'OFF' : _ref$inactiveText,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;

  var handleClick = !disabled && typeof onToggle === 'function' ? onToggle : function () {
    return null;
  };

  return React.createElement(
    ToggleWrapper,
    { checked: checked, containerWidth: width, containerHeight: height },
    React.createElement(
      StyledBG,
      null,
      React.createElement(
        StyledLeft,
        null,
        activeText
      ),
      React.createElement(
        StyledRight,
        null,
        inactiveText
      )
    ),
    React.createElement(StyledHandle, null),
    React.createElement('input', { type: 'checkbox', checked: checked, onChange: function onChange() {
        return handleClick(!checked);
      }, disabled: disabled })
  );
};

OnOffToggle.displayName = 'OnOffToggle';

OnOffToggle.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: PropTypes.bool,
  onToggle: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  activeText: PropTypes.string,
  inactiveText: PropTypes.string,
  disabled: PropTypes.bool
} : {};

export default OnOffToggle;